import us_msk_en from '@us/app/assets/img/qr-msk-us-en.png'
import us_msk_es from '@us/app/assets/img/qr-msk-us-es.png'
import us_copd_en from '@us/app/assets/img/qr-copd-us-en.png'
import us_copd_es from '@us/app/assets/img/qr-copd-us-es.png'
import eu_msk_en from '@eu/app/assets/img/qr-msk-eu-en.png'
import eu_msk_de from '@eu/app/assets/img/qr-msk-eu-de.png'
import eu_copd_en from '@eu/app/assets/img/qr-copd-eu-en.png'
import eu_copd_de from '@eu/app/assets/img/qr-copd-eu-de.png'
import env from '@shared/env.js'

const urls = {
  us_msk_en,
  us_msk_es,
  us_copd_en,
  us_copd_es,
  eu_msk_en,
  eu_msk_de,
  eu_copd_en,
  eu_copd_de,
}

export default function getQRCodeUrl(lang) {
  lang = ['de', 'es'].find((l) => lang?.startsWith(l)) ?? 'en'
  return urls[`${env.VITE_GEO}_${env.VITE_DISEASE}_${lang}`]
}
